/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   styles.ts
 */

import { Theme, css } from '@emotion/react'

export const dots = css`
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  list-style-type: none;
  gap: 4px;
  > li {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const activeDot = ({ colors }: Theme) => css`
  font-family: Arial;
  color: ${colors?.backgroundLightest};
`

export const dot = css`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  padding: 0px;
  border: 0px;
  cursor: pointer;
`

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
`

export const maxDots = css`
  display: flex;
  justify-content: flex-start;
`
